import { render, staticRenderFns } from "./ModalBatchAdd.vue?vue&type=template&id=2d94be3e&scoped=true"
import script from "./ModalBatchAdd.vue?vue&type=script&lang=js"
export * from "./ModalBatchAdd.vue?vue&type=script&lang=js"
import style0 from "./ModalBatchAdd.vue?vue&type=style&index=0&id=2d94be3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d94be3e",
  null
  
)

export default component.exports